var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnlockLimit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -12,
    y: -12,
    width: 120,
    height: 120
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_0_18579_3706_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 95,
    rx: 47.5,
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375 39.625V43H53.625V39.625C53.625 36.5172 51.1078 34 48 34C44.8922 34 42.375 36.5172 42.375 39.625ZM37.875 43V39.625C37.875 34.0352 42.4102 29.5 48 29.5C53.5898 29.5 58.125 34.0352 58.125 39.625V43H59.25C61.732 43 63.75 45.018 63.75 47.5V61C63.75 63.482 61.732 65.5 59.25 65.5H36.75C34.268 65.5 32.25 63.482 32.25 61V47.5C32.25 45.018 34.268 43 36.75 43H37.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_18579_3706_clip_path",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlockLimit);
export default __webpack_public_path__ + "static/media/ic_unlock_limit.c12564dd0f93c8e5e316812351bb4a43.svg";
export { ForwardRef as ReactComponent };